var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row setting-page"},[_c('div',{staticClass:"col-12"},[_c('h2',{staticClass:"text-center mt-3 coming-soon"},[_vm._v(" "+_vm._s(_vm.$t('coming-soon'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }